<template>
  <el-tabs
      v-model="activeName"
      type="card"
      class="demo-tabs"
      @tab-click="handleClick"
  >

    <el-tab-pane label="主参数" name="first" style="padding-left: 100px;width: 90%">

      <el-form :inline="true" :model="formData" class="demo-form-inline" label-width="150px">
        <el-form-item label="产品分类">
          <el-select v-model="formData.catalog" class="m-2" placeholder="Select">
            <el-option v-for="item in catalogList" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="计算模板">
          <el-select v-model="formData.template" class="m-2" placeholder="Select">
            <el-option v-for="item in tempList" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" >加载主参数</el-button>
          <el-button type="danger" >执行计算</el-button>
        </el-form-item>
      </el-form>

      <el-collapse v-model="activeNames" >
        <el-collapse-item title="外部尺寸" name="group1" style="background-color: lightgray">
          <el-row class="param_title">
            <el-col :span="3">参数名</el-col>
            <el-col :span="3">参考值</el-col>
            <el-col :span="3">单位</el-col>
            <el-col :span="3">最大</el-col>
            <el-col :span="3">最小</el-col>
            <el-col :span="3">输入值</el-col>
            <el-col :span="6">备注</el-col>
          </el-row>

          <el-row class="param_row">
            <el-col :span="3">长度</el-col>
            <el-col :span="3">4400</el-col>
            <el-col :span="3">毫米</el-col>
            <el-col :span="3">6600</el-col>
            <el-col :span="3">3600</el-col>
            <el-col :span="3">
              <el-input v-model="paramData.length" placeholder="请输入新数据" />
            </el-col>
            <el-col :span="6"></el-col>
          </el-row>

          <el-row class="param_row">
            <el-col :span="3">宽度</el-col>
            <el-col :span="3">800</el-col>
            <el-col :span="3">毫米</el-col>
            <el-col :span="3">1100</el-col>
            <el-col :span="3">600</el-col>
            <el-col :span="3">
              <el-input v-model="paramData.width" placeholder="请输入新数据" />
            </el-col>
            <el-col :span="6"><span style="padding-left: 10px">含支架</span></el-col>
          </el-row>

          <el-row class="param_row">
            <el-col :span="3">高度</el-col>
            <el-col :span="3">300</el-col>
            <el-col :span="3">毫米</el-col>
            <el-col :span="3">280</el-col>
            <el-col :span="3">450</el-col>
            <el-col :span="3">
              <el-select v-model="formData.height" class="m-2" placeholder="Select">
                <el-option v-for="item in heightList" :key="item.value" :label="item.label" :value="item.value"/>
              </el-select>
            </el-col>
            <el-col :span="6"><span style="padding-left: 10px">下拉框选择</span></el-col>
          </el-row>
        </el-collapse-item>

        <el-collapse-item title="性能指标" name="group2" style="background-color: lightgray">
          <el-row class="param_title">
            <el-col :span="3">参数名</el-col>
            <el-col :span="3">参考值</el-col>
            <el-col :span="3">单位</el-col>
            <el-col :span="3">最大</el-col>
            <el-col :span="3">最小</el-col>
            <el-col :span="3">输入值</el-col>
            <el-col :span="6">备注</el-col>
          </el-row>

          <el-row class="param_row">
            <el-col :span="3">工作压力</el-col>
            <el-col :span="3">20</el-col>
            <el-col :span="3">兆帕</el-col>
            <el-col :span="3">15</el-col>
            <el-col :span="3">33</el-col>
            <el-col :span="3">
              <el-input v-model="paramData.press" placeholder="请输入新数据" />
            </el-col>
            <el-col :span="6"></el-col>
          </el-row>

          <el-row class="param_row">
            <el-col :span="3">最高温</el-col>
            <el-col :span="3">60</el-col>
            <el-col :span="3">摄氏度</el-col>
            <el-col :span="3">50</el-col>
            <el-col :span="3">80</el-col>
            <el-col :span="3">
              <el-input v-model="paramData.temperatureHigh" placeholder="请输入新数据" />
            </el-col>
            <el-col :span="6"></el-col>
          </el-row>

          <el-row class="param_row">
            <el-col :span="3">最低温</el-col>
            <el-col :span="3">-10</el-col>
            <el-col :span="3">摄氏度</el-col>
            <el-col :span="3">0</el-col>
            <el-col :span="3">-20</el-col>
            <el-col :span="3">
              <el-input v-model="paramData.temperatureLow" placeholder="请输入新数据" />
            </el-col>
            <el-col :span="6"></el-col>
          </el-row>
        </el-collapse-item>

        <el-collapse-item title="参数分组3" name="group3" style="background-color: lightgray">
        </el-collapse-item>

        <el-collapse-item title="参数分组4" name="group4" style="background-color: lightgray">
        </el-collapse-item>

      </el-collapse>

      <el-form :inline="true" :model="formData" class="demo-form-inline" label-width="150px" style="margin-top: 20px">
        <el-form-item label="SW6计算结果">
          <el-upload
              v-model:file-list="fileList"
              class="upload-demo"
              action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15"
              :limit="1"
          >
            <el-button type="primary">上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>



    </el-tab-pane>

    <el-tab-pane label="计算参数" name="third" style="padding-left: 100px;width: 90%">
      <el-collapse v-model="activeNames2" >
        <el-collapse-item title="设计概述" name="group1" style="background-color: lightgray">
          <el-row class="param_title">
            <el-col :span="3">参数名</el-col>
            <el-col :span="3">参考值</el-col>
            <el-col :span="3">单位</el-col>
            <el-col :span="3">计算值</el-col>
            <el-col :span="3">输入值</el-col>
            <el-col :span="9">备注</el-col>
          </el-row>

          <el-row class="param_row">
            <el-col :span="3">产品型号</el-col>
            <el-col :span="3">CFL-50/0.80</el-col>
            <el-col :span="3"></el-col>
            <el-col :span="3">CFL-50/0.80</el-col>
            <el-col :span="3">
              <el-input v-model="calcData.value1" placeholder="请输入矫正数据" />
            </el-col>
            <el-col :span="9"></el-col>
          </el-row>

          <el-row class="param_row">
            <el-col :span="3">几何容积</el-col>
            <el-col :span="3">50</el-col>
            <el-col :span="3">立方米</el-col>
            <el-col :span="3">80</el-col>
            <el-col :span="3">
              <el-input v-model="paramData.value2" placeholder="请输入矫正数据" />
            </el-col>
            <el-col :span="9">公式:长x宽x高</el-col>
          </el-row>

          <el-row class="param_row">
            <el-col :span="3">有效容积</el-col>
            <el-col :span="3">40</el-col>
            <el-col :span="3">立方米</el-col>
            <el-col :span="3">68</el-col>
            <el-col :span="3">
              <el-input v-model="paramData.value3" placeholder="请输入矫正数据" />
            </el-col>
            <el-col :span="9">公式:长x宽x高</el-col>
          </el-row>

          <el-row class="param_row">
            <el-col :span="3">额定充满率</el-col>
            <el-col :span="3">90</el-col>
            <el-col :span="3">%</el-col>
            <el-col :span="3">88</el-col>
            <el-col :span="3">
              <el-input v-model="paramData.value4" placeholder="请输入矫正数据" />
            </el-col>
            <el-col :span="9">V_i1=2.2417m^3</el-col>
          </el-row>
        </el-collapse-item>

        <el-collapse-item title="主要技术参数" name="group2" style="background-color: lightgray">
          <el-row class="param_title">
            <el-col :span="3">参数名</el-col>
            <el-col :span="3">参考值</el-col>
            <el-col :span="3">单位</el-col>
            <el-col :span="3">计算值</el-col>
            <el-col :span="3">输入值</el-col>
            <el-col :span="9">备注</el-col>
          </el-row>

          <el-row class="param_row">
            <el-col :span="3">工作压力</el-col>
            <el-col :span="3">0.80</el-col>
            <el-col :span="3">兆帕</el-col>
            <el-col :span="3">0.80</el-col>
            <el-col :span="3">
              <el-input v-model="calcData.value5" placeholder="请输入矫正数据" />
            </el-col>
            <el-col :span="9"></el-col>
          </el-row>

          <el-row class="param_row">
            <el-col :span="3">设计压力</el-col>
            <el-col :span="3">0.88</el-col>
            <el-col :span="3">兆帕</el-col>
            <el-col :span="3">0.98</el-col>
            <el-col :span="3">
              <el-input v-model="paramData.value6" placeholder="请输入矫正数据" />
            </el-col>
            <el-col :span="9"></el-col>
          </el-row>

          <el-row class="param_row">
            <el-col :span="3">强化压力（水压）</el-col>
            <el-col :span="3">1.47</el-col>
            <el-col :span="3">兆帕</el-col>
            <el-col :span="3">1.50</el-col>
            <el-col :span="3">
              <el-input v-model="paramData.value7" placeholder="请输入矫正数据" />
            </el-col>
            <el-col :span="9"></el-col>
          </el-row>

          <el-row class="param_row">
            <el-col :span="3">安全阀开启压力</el-col>
            <el-col :span="3">0.84</el-col>
            <el-col :span="3">兆帕</el-col>
            <el-col :span="3">0.85</el-col>
            <el-col :span="3">
              <el-input v-model="paramData.value8" placeholder="请输入矫正数据" />
            </el-col>
            <el-col :span="9"></el-col>
          </el-row>
        </el-collapse-item>

        <el-collapse-item title="容积计算" name="group3" style="background-color: lightgray"></el-collapse-item>
        <el-collapse-item title="液柱静压力计算" name="group4" style="background-color: lightgray"></el-collapse-item>
        <el-collapse-item title="封头设计计算" name="group5" style="background-color: lightgray"></el-collapse-item>
        <el-collapse-item title="筒体设计计算" name="group6" style="background-color: lightgray"></el-collapse-item>
        <el-collapse-item title="开孔补强计算" name="group7" style="background-color: lightgray"></el-collapse-item>

        <el-collapse-item title="外封头外压校核" name="group8" style="background-color: lightgray"></el-collapse-item>
        <el-collapse-item title="外筒体（一）外压校核" name="group9" style="background-color: lightgray"></el-collapse-item>
        <el-collapse-item title="外筒体（二）外压校核" name="group10" style="background-color: lightgray"></el-collapse-item>
        <el-collapse-item title="径向支撑受力计算" name="group11" style="background-color: lightgray"></el-collapse-item>
        <el-collapse-item title="钢管支撑的强度校核" name="group12" style="background-color: lightgray"></el-collapse-item>
        <el-collapse-item title="安全泄放量的计算" name="group13" style="background-color: lightgray"></el-collapse-item>
        <el-collapse-item title="安全附件排放能力计算" name="group14" style="background-color: lightgray"></el-collapse-item>

      </el-collapse>
    </el-tab-pane>

    <el-tab-pane label="结果输出" name="fourth"  style="padding-left: 100px;width: 90%">
      <el-button type="primary">预览</el-button>
      <el-button type="primary">下载Excel</el-button>
      <el-button type="primary">下载Pdf</el-button>

      <div style="width: 90%;height: 800px;border: 1px solid #e5e5e5;margin-top: 20px;padding: 20px">
        <div>这里预览pdf内容</div>
        <div>这里预览pdf内容</div>
        <div>这里预览pdf内容</div>
        <div>这里预览pdf内容</div>
      </div>
    </el-tab-pane>

    <el-tab-pane label="执行日志" name="log"  style="padding: 30px;width: 90%">
      <el-input v-model="logs" type="textarea" :rows="200" readonly/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: "calc",
  data(){
    return {
      activeName: 'first',
      activeNames:['group1'],
      activeNames2:['group1','group2'],
      formData:{catalog:'chu_guan', template:'temp1'},
      paramData:{length:4500, width:600,height:280, press:20, temperatureHigh:70, temperatureLow:-10},
      calcData:{value1:'', value2:'',value3:280, value4:'', value5:'', value6:'', value7:'', value8:'', value9:-10},
      catalogList:[{value:'chu_guan', label:"储罐"},{value:'chao_che', label:"槽车"},{value:'qi_pin', label:"气瓶"}],
      tempList:[{value:'temp1', label:"高压罐"},{value:'temp2', label:"耐腐蚀罐"},{value:'temp3', label:"低温罐"}],
      heightList:[{value:'280', label:"280"},{value:'300', label:"300"},{value:'360', label:"360"}],
      logs:'2022-12-13 12:54:21 载入主参数成功\n2022-12-13 12:54:22 开始计算\n2022-12-13 12:54:23 校验输入项\n2022-12-13 12:54:24 ......\n '
    }
  },
  methods: {
    handleClick() {

    }
  }
}
</script>

<style scoped>

.param_group{
  line-height: 40px;
  background-color: #a2c5ff;
  font-size: larger;
  margin-top: 20px;
}

.param_title{
  background-color: lightgray;
}

</style>